import { useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toast";

import { useEnsNftContract } from "./useContract"
import { handleWalletError } from "../utils";
import config from "../config";
import useAppCtx from "./useAppCtx";
import useEnsTokens from "./useEnsTokens";


const useEnsForge = () => {
    const contract = useEnsNftContract();
    const [approvePending, setApprovePending] = useState(false);
    const { setTxInProgress, setTxEtherScan, txEtherscan, txInProgress } = useAppCtx();
    const { getTokens } = useEnsTokens();
    const history = useHistory();

    const forgeAll = async (tokenIds) => {
        if (approvePending) return;
        if (contract) {
            setApprovePending(true);
            let gasLimit = await contract.estimateGas
                .forgeAll(tokenIds)
                .catch(handleWalletError);

            if (gasLimit) {
                await contract
                    .forgeAll(tokenIds)
                    .then((tx) => {
                        setApprovePending(false);
                        setTxInProgress(true);
                        console.log(`${config.ETHERSCAN_URL}tx/${tx.hash}`);
                        setTxEtherScan(`${config.ETHERSCAN_URL}tx/${tx.hash}`);
                        return tx.wait().then((receipt) => {
                            if (receipt && receipt.status === 1) {
                                setTxInProgress(false);
                                setTxEtherScan(null);
                                getTokens();
                                toast.success("Forge successful!");

                                history.replace({ ...history.location, state: null });
                                history.push({
                                    pathname: "/wallet",
                                });
                            } else {
                                toast.error("Transaction Failed");
                                setTxInProgress(false);
                                setTxEtherScan(null);
                            }
                        });
                    })
                    .catch(handleWalletError);
            }
            setTxInProgress(false);
            setApprovePending(false);
        } else {
            console.error("Failed to instantiate Ens Contract!")
        }
    }
    return {
        forgeAll,
        approvePending,
        txInProgress,
        txEtherscan
    }
}

export default useEnsForge